// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8359":"85805728","9084":"6dd59d54"}[chunkId] + ".chunk.css";
};